<template>
  <div>
    <div class="page-header clear-filter"  style="max-height: 100%!important;">
      <parallax
        class="page-header-image"
        style="z-index:0;background-image:url('img/background.png')"
      >
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <img class="n-logo" style="max-width:650px!important;width:100%!important;" src="img/now-logo.png" alt="" />
          <h3>Smooth wheels to your destination.</h3>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="section section-images d-none d-xl-block d-lg-block" style="padding:0px!important;background:#F9F9F9;">
        <div class="container" style="max-width:80%;padding:0px!important;">
          <div class="row" style="z-index:344!important;padding:0px!important;">
            <div class="col-lg-6">
              <div  class="hero-images-container" style="overflow:hidden;z-index:344!important;transform:scale(2);align:left;margin-top:12%;max-width:100%!important;">
                <img style="overflow:hidden;" src="img/phone.png" alt="" />
              </div>
            </div>
            <div class="col-lg-6 d-none d-xl-block d-lg-block" style="padding: 5rem;">
              <h2 style="padding-top:10px;" class="title">Discover what all the buzz is about!</h2>
              <h5 class="description" style="color:#000;">
                Click here to find us on  Google Play Store and get the app running on your phone!
              </h5>
              <a
                      href="https://play.google.com/store/apps/details?id=com.himanshubhalani"
                      target="_blank"
                      style="margin-top:200px;"
              >
                <img style="margin-top:80px; max-width: 300px!important;" v-lazy="'img/google-play-badge.svg'" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-images d-xl-none d-lg-none" style="height:auto;padding-left:14%;padding:0px!important;background:#F9F9F9;">
        <div class="container" style="max-width:80%;padding:0px!important;">
          <div class="row" style="z-index:344!important;padding:0px!important;">
            <div class="col-lg-6">
              <div  class="hero-images-container" style="overflow:hidden;z-index:344!important;transform:scale(1);align:left;margin-top:-20%;width:100%!important;">
                <img style="overflow:hidden;" src="img/phone1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="padding-top:4rem!important;background:#F9F9F9;">
        <div class="container" style="max-width:80%;padding:0px!important;">
          <div class="row" style="z-index:344!important;padding:0px!important;">
            <div class="col-lg-6 d-block d-xl-none d-lg-none" style="padding: 2.6rem;">
              <h2 style="padding-top:10px;" class="title">Discover what all the buzz is about!</h2>
              <h5 class="description" style="color:#000;">
                Click here to find us on  Google Play Store and get the app running on your phone!
              </h5>
              <a
                      href="https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.himanshubhalani"
                      target="_blank"
                      style="margin-top:200px;"
              >
                <img style="margin-top:80px; max-width: 300px!important;" v-lazy="'img/google-play-badge.svg'" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section" style="background: #F9F9F9;padding-top:6%;">
      <div class="container text-center">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Overview</h2>
            <h5 class="description" style="color:#000;">
              Transpo is a product that provides a bridge between the students and the cab service providers and allows them to book secure rides to their destination with ease.
              Currently, Transpo plans on providing services in Manipal University Jaipur.
            </h5>
          </div>
        </div>
      </div>
    </div>
    <signup-form></signup-form>
    <download-section></download-section>
  </div>
</template>
<script>
import SignupForm from './components/SignupForm';
import ExamplesSection from './components/ExamplesSection';
import DownloadSection from './components/DownloadSection';
import SlideYUpTransition from "vue2-transitions/src/Slide/SlideYUpTransition";

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    SlideYUpTransition,
    SignupForm,
    ExamplesSection,
    DownloadSection
  }
};
</script>
<style>
  .index-page .page-header{
    height:100vh!important;
  }
  .section-images{
    max-height: 600px!important;
  }
  .n-logo{
    max-width:300px!important;
    /*padding-top:60px;*/
  }
  .index-page .page-header .container > .content-center{
    top:46%!important;
  }
  /*.clear-filter {*/
  /*  z-index:999;*/
  /*}*/
</style>
